import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, UserCheck, Calendar, Activity } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface StatsProps {
  stats: {
    totalCoaches: number;
    totalCustomers: number;
    activeCustomers: number;
    pendingAppointments: number;
  };
}

export function DashboardStats({ stats }: StatsProps) {
  const { t } = useLanguage();

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 p-3 md:p-4 lg:p-6 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium truncate pr-2">{t('dashboard.admin.stats.totalCoaches')}</CardTitle>
          <Users className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#004250] flex-shrink-0" />
        </CardHeader>
        <CardContent className="p-3 md:p-4 lg:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.totalCoaches}</div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 p-3 md:p-4 lg:p-6 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium truncate pr-2">{t('dashboard.admin.stats.totalCustomers')}</CardTitle>
          <UserCheck className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#7dda55] flex-shrink-0" />
        </CardHeader>
        <CardContent className="p-3 md:p-4 lg:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.totalCustomers}</div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 p-3 md:p-4 lg:p-6 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium truncate pr-2">{t('dashboard.admin.stats.activeCustomers')}</CardTitle>
          <Activity className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#7dda55] flex-shrink-0" />
        </CardHeader>
        <CardContent className="p-3 md:p-4 lg:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.activeCustomers}</div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 p-3 md:p-4 lg:p-6 pb-2">
          <CardTitle className="text-xs md:text-sm font-medium truncate pr-2">{t('dashboard.admin.stats.pendingAppointments')}</CardTitle>
          <Calendar className="h-3.5 w-3.5 md:h-4 md:w-4 text-[#004250] flex-shrink-0" />
        </CardHeader>
        <CardContent className="p-3 md:p-4 lg:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.pendingAppointments}</div>
        </CardContent>
      </Card>
    </>
  );
}